import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Header2 } from '@/shared/theme/styled-components'

const ErrorFallback = ({ resetErrorBoundary, containerName }) => {
  const { t } = useTranslation()

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <Header2>{t('common:error_boundary_title')}</Header2>
      <p>{t('common:error_boundary_message', { containerName })}</p>
      <button onClick={resetErrorBoundary}>{t('common:error_boundary_retry')}</button>
    </div>
  )
}

ErrorFallback.propTypes = {
  resetErrorBoundary: PropTypes.func.isRequired,
  containerName: PropTypes.string.isRequired,
}

export default ErrorFallback
